/**
 * Page layout wrapper with a sticky header (large heading, optional subheading,
 * optional headerAction node, configurable headerColor) above scrollable
 * children. Used across bounty pages (BountyCreateEdit, SubheadedBountyDisplay,
 * BountyViewSubmit), account pages (Listings, Pursuits, Submissions,
 * BountySubmissions, Payments, Account, NotificationSettings), and
 * SubmissionDisplay.
 */
interface SubheadedPageProps {
    heading: string;
    subheading?: string;
    children: React.ReactNode;
    className?: string;
    headerAction?: React.ReactNode;
    headerColor?: string;
}

export const SubheadedPage: React.FC<SubheadedPageProps> = ({
    children,
    heading,
    subheading = "",
    className,
    headerColor = "bg-slate-50 opacity-80",
    headerAction,
}) => {
    return (
        <div className={`w-full flex flex-col bg-transparent ${className || ""}`}>
            <div
                className={`sticky top-0 w-full flex flex-col text-black font-porsui p-8 z-10 ${headerColor}`}
            >
                {headerAction}
                <h1 className="text-4xl tracking-wide">{heading}</h1>
                {subheading && <h2 className="text-1xl tracking-widest mt-4 ml-1">{subheading}</h2>}
            </div>
            <div className="pb-20">{children}</div>
        </div>
    );
};
